var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'react-emotion';
export var Wrapper = styled('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  height: 100%;\n  justify-content: center;\n  gap: 5px;\n"], ["\n  display: flex;\n  height: 100%;\n  justify-content: center;\n  gap: 5px;\n"])));
var templateObject_1;
//# sourceMappingURL=ActionsGenerator.Styles.js.map